import { table } from './_table';

export const contacts = {
  namespaced: true,
  modules: {
    table
  }
};
